// extracted by mini-css-extract-plugin
export default {"container":"InviteDate_container__6yqdd","title":"InviteDate_title__2s4EG","content":"InviteDate_content__0NbCL","date":"InviteDate_date__b1HGY","time":"InviteDate_time__mrmJj"};